import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';

import { Customer, KnowledgeBaseArticle } from 'src/models';
import { SearchablePopoverService } from 'src/services/searchable-popover.service';

@Component({
  selector: 'app-bulk-manage-channels',
  templateUrl: './bulk-manage-channels.component.html',
  styleUrls: ['./bulk-manage-channels.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule],
})
export class BulkManageChannelsComponent implements OnInit {
  @Input() articles: Partial<KnowledgeBaseArticle>[] = [];
  @Input() availableChannels: Customer[] = [];

  initialSelectedChannelIds = new Set<string>();
  selectedChannelsMap = new Map<string, Customer>();
  articleIds: string[] = [];

  constructor(
    private modalCtrl: ModalController,
    private searchablePopoverService: SearchablePopoverService,
  ) {}

  ngOnInit(): void {
    if (!this.articles || this.articles.length === 0) {
      console.warn('BulkManageChannelsComponent: No articles provided.');
      this.dismissModal();
      return;
    }

    this.articleIds = this.articles.map((a) => a.id).filter((id): id is string => !!id);

    const unionChannelIds = new Set<string>();
    for (const article of this.articles) {
      (article.channelIds ?? []).forEach((channelId) => {
        unionChannelIds.add(channelId);
      });
    }

    this.initialSelectedChannelIds = unionChannelIds;

    this.selectedChannelsMap.clear();
    this.initialSelectedChannelIds.forEach((id) => {
      const channel = this.availableChannels.find((c) => c.id === id);
      if (channel) {
        this.selectedChannelsMap.set(id, channel);
      }
    });
  }

  addChannel(event: MouseEvent) {
    const currentlySelectedIds = Array.from(this.selectedChannelsMap.keys());
    this.searchablePopoverService.customers({
      event,
      excludeIds: currentlySelectedIds,
      callback: (id: string, name: string, selectedChannel: Customer | null) => {
        if (id && selectedChannel && !this.selectedChannelsMap.has(id)) {
          this.selectedChannelsMap.set(id, selectedChannel);
        }
      },
    });
  }

  removeChannel(channelId: string) {
    if (this.selectedChannelsMap.has(channelId)) {
      this.selectedChannelsMap.delete(channelId);
    }
  }

  get selectedChannelsArray(): Customer[] {
    return Array.from(this.selectedChannelsMap.values());
  }

  trackByChannelId(index: number, channel: Customer): string {
    return channel.id;
  }

  dismissModal(): void {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  applyChanges(): void {
    const result = {
      articleIds: this.articleIds,
      finalChannelIds: Array.from(this.selectedChannelsMap.keys()),
    };
    this.modalCtrl.dismiss(result, 'apply');
  }
}
